import React, { useEffect } from 'react';
import { Typography, Button } from '@ann/web-components';
import { HeaderContainer, HeaderContent, HeaderDescription } from './Header.styled';
import { useStore } from '../../../../../hooks';
import { observer } from 'mobx-react';
import { Alert } from '@ann/web-components';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const Header = observer(() => {
    const { playgroundConfigStore, authStore } = useStore();
    const { agentStore } = playgroundConfigStore;
    const userId = authStore.userId;
    const navigate = useNavigate();

    useEffect(() => {
        if (agentStore.agentCreated) {
            agentStore.setAgentCreated(false);
        }
    }, []);

    const handleCreateAgent = async () => {
        const date = new Date();
        const agentName = `${authStore.currentUserFirstName} New Agent ${dayjs(date).format('MM-DD-YYYY HH:mm:ss')}`;
        const data = {
            name: agentName,
            owner: userId,
            createdBy: userId,
        };
        
        await agentStore.createAgent(data);
    }

    const handleAlertClose = () => {
        const uuidToNavigate = agentStore.uuid;
        agentStore.setAgentCreated(false);
        
        if (uuidToNavigate) {
            navigate(`/v2/playground2/${uuidToNavigate}/configuration`);
        }
    };

    return (
        <>
        <HeaderContainer>
            <HeaderContent>
                <Typography
                    category="title"
                    size="large"
                    weight="bold"
                    color="title"
                >
                    Agents
                </Typography>
                <Typography
                    category="body"
                    size="small"
                    weight="regular"
                    color="body"
                >
                    Manage agents to automate tasks and improve customer support.
                </Typography>
            </HeaderContent>
            <Button
                label="Create"
                size="medium"
                type="gradient"
                onClick={handleCreateAgent}
                disabled={agentStore.isCreating}
            />
        </HeaderContainer>
        {agentStore.agentCreated && (
            <Alert
                title=""
                description="Agent created successfully."
                severity="success"
                maxWidth="500px"
                closable={false}
                autoClose={true}
                autoCloseDelay={1000}
                onClose={handleAlertClose}
            />
        )}
        {agentStore.errorCreatingAgent && (
            <Alert
                title="Error"
                description={agentStore.error || "Error creating agent"}
                severity="error"
                maxWidth="500px"
                closable={true}
                onClose={() => agentStore.errorCreatingAgent = false}
            />
        )}
        </>
    );
});

export default Header;